import { regexp } from './regexp'

export const validator = value => value && (new RegExp(`^${regexp}$`, 'i')).test(value)
